<template>
    <AppLayout>
        <div class="container p-4 mx-auto md:px-36 md:py-4">
            <div class="mb-4 text-xl font-semibold md:text-2xl">
                About Us
            </div>

            <div>
                <p class="my-4">
                    <inertia-link
                        href="/"
                        class="text-green-500"
                    >
                        Humtt.com
                    </inertia-link> is a network-based business to business (B2B) trading platform, designed particularly for small size businesses and also for medium and large businesses in <strong>Trinidad and Tobago</strong>. This system brings almost all wholesalers, retailers, manufacturers of Trinidad and Tobago onto a single platform. Humtt.com introduces the power of technology to nurture and scale up businesses for all parties by providing real insights into active trends and great B2B trade features.
                </p>
                <p>
                    <inertia-link
                        href="/"
                        class="text-green-500"
                    >
                        Humtt.com
                    </inertia-link> has the feature 'easy-to-use' which gives to power
                </p>
                <ul
                    class="my-4 mx-8"
                    style="list-style-type: square"
                >
                    <li><strong>DISCOVER</strong> customers, suppliers & products across numerous categories</li>
                    <li><strong>BUY & SELL</strong> on your terms – smooth logistics</li>
                    <li><strong>GROW</strong> your network through repeats & relationships with like-minded parties</li>
                </ul>
                <p class="my-4">
                    <inertia-link
                        href="/"
                        class="text-green-500"
                    >
                        Humtt.com
                    </inertia-link> helps traders to reach out to almost all wholesalers, manufacturers and retailers across the country.
                </p>
                <ul
                    class="my-4 list-disc mx-8"
                    style="list-style-type: square"
                >
                    <li>
                        Retailers/Business owners can discover & buy a wide range of quality products at best wholesale prices. <inertia-link
                            href="/"
                            class="text-green-500"
                        >
                            Humtt.com
                        </inertia-link> caters to products from multiple categories like Hardware, Electronics & Appliances, Clothing & Accessories, Footwear, Food & FMCG, Pharmaceuticals/Medicines, Home & Kitchens, Electricals, Toys, Baby & Sports and more.
                    </li>
                    <li>
                        Suppliers can get orders from buyers across the country.
                    </li>
                    <li>
                        GROW your network through repeats & relationships with like-minded parties
                    </li>
                </ul>
                <p class="my-4">
                    <inertia-link
                        href="/"
                        class="text-green-500"
                    >
                        Humtt.com
                    </inertia-link> makes purchase and selling very simple.
                </p>
                <p class="my-4">
                    Quick doorstep delivery through our well built, safe logistics, supply chain & fulfillment systems.
                </p>
                <p class="my-4">
                    Have any issues with the product delivered? Our returns process is easy and simple.
                </p>
                <p class="my-4">
                    <inertia-link
                        href="/"
                        class="text-green-500"
                    >
                        Humtt.com
                    </inertia-link> offers credit facility & financing options to buyers & sellers respectively based on the eligibility criteria*.
                </p>
                <p class="my-4">
                    <inertia-link
                        href="/"
                        class="text-green-500"
                    >
                        Humtt.com
                    </inertia-link> is a platform for you to grow your network for future business, even as you buy and sell.
                </p>
            </div>
        </div>
    </AppLayout>
</template>

<script>
import AppLayout from '../../Layouts/AppLayout.vue';

export default {
    name: 'AboutUsIndex',

    components: {
        AppLayout,
    },
};
</script>
